module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0099.png.d4a8d23d.jpg";